import { IAgentSourcedCreatorFilters } from '../types'

// BRAND-9550: the select-all-pending bulk reject sends a SCOPE FLAG instead of
// an id list, so the BE re-resolves the set from the same filters the list
// request used. Any drift between "what the list query selects" and "what the
// reject body scopes to" is a silent wrong-set rejection — exactly the class
// of bug this ticket exists to kill — so both are built from these helpers
// rather than from two hand-maintained copies.
//
// Values are CSV-joined, matching how the list endpoint has always received
// multi-value filters via the query string (see fetchCreators' URL building).

// Filters that change SET MEMBERSHIP. Insertion order is meaningful: the list
// request serialises these into the query string in this order.
export const buildScopeFilterParams = (
  filters: IAgentSourcedCreatorFilters | undefined,
): Record<string, string> => {
  const params: Record<string, string> = {}
  if (!filters) return params
  if (filters.platforms?.length) params.platforms = filters.platforms.join(',')
  if (filters.age_ranges?.length) params.age_ranges = filters.age_ranges.join(',')
  // NOTE(BRAND-9367): sends CSV multi-value; BE must accept like age_ranges/locations
  if (filters.engagement_rate?.length) params.engagement_rate = filters.engagement_rate.join(',')
  if (filters.followers?.length) params.followers = filters.followers.join(',')
  if (filters.locations?.length) params.locations = filters.locations.join(',')
  if (filters.views?.length) params.views = filters.views.join(',')
  if (filters.last_post_within) params.last_post_within = filters.last_post_within
  return params
}

// Ordering only. Deliberately NOT part of the scope params above: sorting
// cannot change which creators are in the set, so it has no business in a
// destructive bulk-reject body.
export const buildSortParams = (
  filters: IAgentSourcedCreatorFilters | undefined,
): Record<string, string> => {
  const params: Record<string, string> = {}
  if (!filters) return params
  if (filters.sort_field) params.sort_field = filters.sort_field
  if (filters.sort_direction) params.sort_direction = filters.sort_direction
  return params
}
